// extracted by mini-css-extract-plugin
var _1 = "ProductInfo_container__ujt9h";
var _2 = "ProductInfo_imageContainer__ggVvL";
var _3 = "ProductInfo_product__iQ4L4";
var _4 = "ProductInfo_productDescription__Xs--q";
var _5 = "ProductInfo_unavailable__2HInT";
export { _1 as "container", _2 as "imageContainer", _3 as "product", _4 as "productDescription", _5 as "unavailable" }
